import { render, staticRenderFns } from "./marker.vue?vue&type=template&id=2610426e"
import script from "./marker.vue?vue&type=script&lang=js"
export * from "./marker.vue?vue&type=script&lang=js"
import style0 from "./marker.vue?vue&type=style&index=0&id=2610426e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports